<template>
  <v-container>
    <v-spacer style="margin-top: 2rem;"></v-spacer>
    <v-row>
      <v-col cols="7" class="left">
        <h1>{{ title }}</h1>
        <h2>{{ subtitle }}</h2>
        <div>
          <slot name="buttons"></slot>
          <div v-if="availableEasyNavCount === 0" class="empty">
            このページで行える事は何もありません。
          </div>
          <easy-back-button/>
        </div>
      </v-col>
      <v-col cols="5" class="right">
        <div v-if="image" class="image" :style="{backgroundImage: `url('${image}')`}"></div>
      </v-col>
    </v-row>
    <go-normal-btn/>
  </v-container>
</template>

<script>
import EasyBackButton from "@/components/pages/easy/EasyBackButton.vue";
import GoNormalBtn from "@/components/pages/easy/GoNormalBtn.vue";

export default {
  name: "EasyPageTemplate",
  components: {GoNormalBtn, EasyBackButton},
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    imageBackground: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      availableEasyNavCount: 0
    };
  },
  provide() {
    return {
      easyNavAvailable: this.easyNavAvailable.bind(this)
    }
  },
  computed: {
    easyNavCount() {
      return !this.$slots['buttons'].filter(b => b.componentOptions.tag === 'easy-nav').length;
    }
  },
  methods: {
    easyNavAvailable(isAvailable) {
      if(isAvailable) {
        this.availableEasyNavCount++;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./easy.scss";

.left {
  text-align: start;
  padding-right: 50px;

  h1 {
    margin-bottom: 0.5rem;

    &:after {
      content: '';
      display: block;
      width: 90%;
      height: 2px;
      background-color: #D8E4ED;
    }
  }

  h2 {
    font-size: 0.8rem;
  }

  .empty {
    margin: 1em 0;
    font-size: 150%;
  }
}

.right {
  .image {
    height: 400px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
}
</style>
